import { render } from "./PayGradeCurrency.vue?vue&type=template&id=079b0ef0"
import script from "./PayGradeCurrency.vue?vue&type=script&lang=js"
export * from "./PayGradeCurrency.vue?vue&type=script&lang=js"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__